import { render, staticRenderFns } from "./select_frequency.vue?vue&type=template&id=0b71357e"
import script from "./select_frequency.vue?vue&type=script&lang=js"
export * from "./select_frequency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports